import * as React from 'react';

import { Wrapper, StyledSwitch } from './styles';

export interface SwitchStyle {
	activeColor?: string;
	inactiveColor?: string;
}

interface SwitchProps {
	name: string;
	isActive: boolean;
	onChange: () => void;
	label?: React.ReactNode;
	style?: SwitchStyle;
}

const Switch = ({
	name,
	isActive,
	onChange,
	label,
	style,
}: SwitchProps) => (
	<Wrapper>
		{label}
		<StyledSwitch
			isActive={isActive}
			style={style}
		>
			<input
				type="checkbox"
				name={name}
				checked={isActive}
				onChange={onChange}
			/>
		</StyledSwitch>
	</Wrapper>
);

export default Switch;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Form/Switch/index.tsx